import Icon from '../components/Icon.vue'

Icon.register({
  pallet: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M144 256H496C504.8 256 512 248.8 512 240V16C512 7.2 504.8 0 496 0H384V128L320 96 256 128V0H144C135.2 0 128 7.2 128 16V240C128 248.8 135.2 256 144 256zM624 384C632.8 384 640 376.8 640 368V336C640 327.2 632.8 320 624 320H16C7.2 320 0 327.2 0 336V368C0 376.8 7.2 384 16 384H64V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448H576V384H624zM288 448H128V384H288V448zM512 448H352V384H512V448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pallet.js
// module id = r2jF
// module chunks = 144